module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_campaign-34cf10b882296c409c71fcc9eef8d6ff.png";